// Generated by Melange

import * as Buhta_components__Text from "../../../../../../packages/components/src/html/Text.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as JsxRuntime from "react/jsx-runtime";

function NcaLayerConnectionErrorModal(Props) {
  let onClose = Props.onClose;
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx(Buhta_components__Text.H4.make, {
                                    children: "Подписание документов"
                                  }),
                              JsxRuntime.jsx("button", {
                                    children: JsxRuntime.jsx("img", {
                                          className: "w-6 h-6",
                                          src: StaticAsset.src("/static/icons/close.svg")
                                        }),
                                    onClick: (function (param) {
                                        Curry._1(onClose, undefined);
                                      })
                                  })
                            ],
                            className: "px-6 py-4 flex justify-between border-b border-gray-main"
                          }),
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("img", {
                                    alt: "error",
                                    src: StaticAsset.src("/static/icons/error-red-40.svg")
                                  }),
                              JsxRuntime.jsx(Buhta_components__Text.H3.make, {
                                    className: "mt-6",
                                    children: "Не удалось подключиться к NCALayer"
                                  }),
                              JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                    className: "mt-2 text-asphalt",
                                    children: "Запустите NCALayer и повторите попытку"
                                  })
                            ],
                            className: "flex flex-col items-center py-10"
                          }),
                      JsxRuntime.jsx("div", {
                            children: JsxRuntime.jsxs(Buhta_components__Text.PSmall.make, {
                                  className: "text-asphalt text-center",
                                  children: [
                                    "Если у вас не установлено приложение NCALayer, то его можно скачать на ",
                                    JsxRuntime.jsx("a", {
                                          children: "официальном сайте",
                                          className: "text-links",
                                          href: "https://ncl.pki.gov.kz/",
                                          target: "_blank"
                                        })
                                  ]
                                }),
                            className: "flex justify-center px-6 py-4 bg-gray-pale"
                          })
                    ],
                    className: "w-120 bg-white rounded shadow-payroll"
                  }),
              className: "absolute inset-0 bg-black/40 flex justify-center items-center z-10"
            });
}

const make = NcaLayerConnectionErrorModal;

export {
  make ,
}
/* Buhta_components__Text Not a pure module */
